import { SelectionType } from './selection-type.enum';

/** Shape of a node as returned by GET /api/v1/advancedSearch/loadLocations */
export interface RawLocationNode {
  type: string;
  key: string;
  name: string;
  typeName?: string;
  fullName?: string;
  relevance?: {
    totalCompanyEaum?: number;
    companyCount?: number;
  };
  children?: RawLocationNode[];
}

/** Flat data payload attached to every internal LocationItem */
export interface LocationItemData {
  type: string;
  key: string;
  name: string;
  typeName: string;
  fullName?: string;
  selectionType: SelectionType;
  relevance?: {
    totalCompanyEaum?: number;
    companyCount?: number;
  };
}

/** Internal tree node (wraps LocationItemData, adds UI state) */
export interface LocationItem {
  key: string;
  parent: LocationItem | null;
  children?: LocationItem[];
  isCollapsed: boolean;
  isActive: boolean;
  data: LocationItemData;
  searchContext: {
    startIdx: number;
    endIdx: number;
  };
}

/** Synthetic pill shown when >= groupingCount items are selected */
export interface GroupedLocationItem {
  key: string;
  isGrouped: true;
  children: LocationItem[];
  data: {
    selectionType: SelectionType;
    name: string;
  };
}

export type SelectedPill = LocationItem | GroupedLocationItem;

export function isGroupedItem(item: SelectedPill): item is GroupedLocationItem {
  return (item as GroupedLocationItem).isGrouped === true;
}
